import { classNames } from "Utils/utils";
import { YesNoToggle } from "../forms/YesNoToggle";
import { MEDICATION_INCIDENT_CATEGORIES } from "../../constants";

export const MedicationFormStep = ({ register, watch, setValue }) => {
  const selected = watch("medication_incident_categories") || [];

  const toggleCategory = (value) => {
    const next = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];
    setValue("medication_incident_categories", next, {
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  return (
    <div className="space-y-8 animate-fadeIn">
      {/* Section: Category of Medication Incident */}
      <section>
        <h3 className="text-sm font-semibold text-gray-900 mb-4">
          Category of Medication Incident
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {MEDICATION_INCIDENT_CATEGORIES.map((category) => (
            <label
              key={category.value}
              className={classNames(
                "flex items-start gap-2 p-3 border rounded-lg cursor-pointer transition-all text-sm",
                selected.includes(category.value)
                  ? "border-blue-500 bg-blue-50 text-blue-700"
                  : "border-gray-200 hover:border-gray-300 text-gray-700"
              )}
            >
              <input
                type="checkbox"
                checked={selected.includes(category.value)}
                onChange={() => toggleCategory(category.value)}
                className="w-4 h-4 text-blue-600 rounded mt-0.5 flex-shrink-0"
              />
              <span>{category.label}</span>
            </label>
          ))}
        </div>
        {/* Others description field */}
        {selected.includes("others") && (
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-900 mb-2">
              If Others, please describe
            </label>
            <input
              type="text"
              {...register("medication_other_description")}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
              placeholder="Please describe the medication incident..."
            />
          </div>
        )}
      </section>

      {/* Section: Possible Reasons */}
      <section>
        <h3 className="text-sm font-semibold text-gray-900 mb-4">
          Possible Reasons for Incident?
        </h3>
        <textarea
          {...register("medication_possible_reasons")}
          rows={4}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
          placeholder="Describe the possible reasons for the medication incident..."
        />
      </section>

      {/* Section: Immediate Action */}
      <section>
        <h3 className="text-sm font-semibold text-gray-900 mb-4">
          What immediate action was taken?
        </h3>
        <textarea
          {...register("medication_immediate_action")}
          rows={4}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
          placeholder="Describe the immediate actions taken..."
        />
      </section>

      {/* Section: Notifications */}
      <section>
        <h3 className="text-sm font-semibold text-gray-900 mb-4">
          Notifications
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
              Is the Coordinator Notified?
            </span>
            <YesNoToggle
              name="coordinator_notified"
              value={watch("coordinator_notified")}
              onChange={(val) => setValue("coordinator_notified", val)}
            />
          </div>
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
              Is the Doctor Notified?
            </span>
            <YesNoToggle
              name="doctor_notified"
              value={watch("doctor_notified")}
              onChange={(val) => setValue("doctor_notified", val)}
            />
          </div>
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <span className="text-sm font-medium text-gray-700">
              Is the Pharmacist Notified?
            </span>
            <YesNoToggle
              name="pharmacist_notified"
              value={watch("pharmacist_notified")}
              onChange={(val) => setValue("pharmacist_notified", val)}
            />
          </div>
        </div>
      </section>
    </div>
  );
};
